interface ShowMoreButtonProps {
  hiddenCount: number;
  /** O que a lista guarda, no plural: entra no rótulo lido pelo leitor de tela. */
  listLabel: string;
  onShowMore(): void;
}

/** O fim de uma lista mostrada aos poucos; some quando não há mais nada escondido. */
export function ShowMoreButton({
  hiddenCount,
  listLabel,
  onShowMore,
}: ShowMoreButtonProps): JSX.Element | null {
  if (hiddenCount === 0) return null;
  return (
    <button
      type="button"
      className="w-full rounded-[12px] border-hair border-rule px-4 py-3 text-[13px] font-medium text-ink"
      aria-label={`Mostrar mais ${listLabel} (${hiddenCount} restantes)`}
      onClick={onShowMore}
    >
      Mostrar mais
      <span className="ml-1 text-ink-muted">({hiddenCount})</span>
    </button>
  );
}
